import React, { Component } from 'react';
import PropTypes from 'prop-types';
/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';
// Material Components
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import BookmarkIcon from '@material-ui/icons/BookmarkBorder';
import IconButton from '@material-ui/core/IconButton';
// Custom Components
import HorizontalSlider from '../../components/HorizontalSlider';
// import ContributeCard from '../../components/contributorCard/contributeCard';
import ProfileLoader from '../../components/ProfileLoader';
import RnFEvent from '../../components/RnFEvent';
import Follower from '../../components/NewFollowerCard';
import VerticalSliders from '../../components/VerticalSlider';
import { shuffle } from 'utils/';

const articleEateryDummyData = {
  title: 'Kumbakonam Degree Coffee',
  location: 'Kormangala, Bangalore',
  cuisine: 'South Indian Tiffin, Tamil-style south indian',
  image: '/img/e6.png',
  story:
    'Walking barefoot on the beach, the waves lapping at my feet. Sitting at a beach-side shack, staring into the endless horizon',
  card: 'eatery',
};

// console.log(articleEateryDummyData);
const articleStoryDummyData = {
  title: "Different local bengaluru eateries to be on every traveller's list",
  story:
    'Walking barefoot on the beach, the waves lapping at my feet. Sitting at a beach-side shack, staring into the endless horizon',
  card: 'story',
  image: '/img/e6.png',
};

const articleListicleDummyData = {
  title: 'Event Name',
  date: '23 Nov 2018',
  location: 'Indranagar, Bangalore',
  image: '/img/e2.png',
  story:
    'Walking barefoot on the beach, the waves lapping at my feet. Sitting at a beach-side shack, staring into the endless horizon',
  card: 'listicle',
};

const EventDummyData = [
  {
    title: 'Event Name',
    date: '23 Nov 2018',
    location: 'Indranagar, Bangalore',
    img: '/img/e6.png',
    story:
      'Streets are an integral part of how a city and its culture has evolved.',
    card: 'event',
    curatedBy: 'Maheima Kapur',
  },
  {
    title: 'Event Name',
    date: '23 Nov 2018',
    location: 'Indranagar, Bangalore',
    img: '/img/e6.png',
    story:
      'Streets are an integral part of how a city and its culture has evolved.',
    card: 'event',
    curatedBy: 'Maheima Kapur',
  },
  {
    title: 'Event Name',
    date: '23 Nov 2018',
    location: 'Indranagar, Bangalore',
    img: '/img/e6.png',
    story:
      'Streets are an integral part of how a city and its culture has evolved.',
    card: 'event',
    curatedBy: 'Maheima Kapur',
  },
  {
    title: 'Event Name',
    date: '23 Nov 2018',
    location: 'Indranagar, Bangalore',
    img: '/img/e6.png',
    story:
      'Streets are an integral part of how a city and its culture has evolved.',
    card: 'event',
    curatedBy: 'Maheima Kapur',
  },
];
const contributorChips = [
  {
    id: 'chip1',
    label: 'Bangalore',
  },
  {
    id: 'chip2',
    label: 'Filter coffee',
  },
  {
    id: 'chip3',
    label: 'South Indian',
  },
  {
    id: 'chip4',
    label: 'Street Food',
  },
  {
    id: 'chip5',
    label: 'Punjabi',
  },
  {
    id: 'chip6',
    label: 'Litti',
  },
  {
    id: 'chip7',
    label: 'Rasmalai',
  },
  {
    id: 'chip8',
    label: 'Bengali Biriyani',
  },
  {
    id: 'chip9',
    label: 'Shawarma',
  },
];

const styles = theme => ({
  media: {
    height: 400,
    background: '#eeeae3',
    backgroundSize: 'cover',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imgContainer: {
    textAlign: 'center',
    color: 'white',
  },
  centered: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  imgBody: {
    color: '#ffff',
  },
  top: {
    marginTop: '10px',
    padding: '20px 0 20px 0',
  },

  contributorImg: {
    height: 300,
  },
  contributorContent: {
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: '-97px',
    width: '80%',
    marginLeft: '10%',
    backgroundColor: '#ffff',
  },
  contBody: {
    color: '#ffff',
    backgroundColor: theme.palette.ternary.main,
    padding: '20px',
  },
  contributorBtn: {
    marginTop: '10px',
    marginBottom: '10px',
    backgroundColor: '#e8e2e0',
    color: '#ca1414',
  },
  eateryCard: {
    textAlign: 'left',
    padding: '10px',
  },
  eventCard: {
    padding: '10px',
    marginTop: '10px',
    backgroundColor: '#C8C8C8',
    paddingBottom: '50px',
  },
  contCard: {
    padding: '20px',
    backgroundColor: 'white',
  },
  whiteContainer: {
    backgroundColor: 'white',
  },
  loadingContainer: {
    position: 'fixed',
    width: '100%',
    top: '50px',
    paddingTop: '50%',
    height: '100%',
    backgroundColor: '#fff',
    zIndex: '1000',
  },
  chip: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.primary.main,
    border: 'none',
  },
});

const styles2 = {
  cont_container: {
    backgroundColor: '#eeeae2',
    width: '100%',
    boxSizing: 'border-box',
    maxWidth: '100%',
    height: '350px',
  },
  profile_name: {
    // marginBottom:'-5px',
    color: 'black',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontSize: '17.1px',
    marginTop: '10px',
    textAlign: 'center',
  },
  avatar_container: {
    textAlign: 'right',
    marginTop: '50px',
    width: '125px',
    height: '125px',
    marginLeft: 'auto',
    marginRight: 'auto',
    border: '2px solid black',
    borderRadius: '100%',
  },
  avatar_pic: {
    width: '113px',
    height: '113px',
    marginTop: '5px',
    marginLeft: 'auto',
    marginRight: 'auto',
    // border:'2px solid white'
  },
  actions: {
    width: '100%',
    color: '#bcbcbc',
    padding: '5px 10px 0px 10px',
    display: 'flex',
    backgroundColor: '#EEB700',
    height: '40px',
    marginTop: '20px',
  },
  actionIcon: {
    backgroundColor: '#bb543e',
    color: 'white',
    margin: '5px',
    // marginTop : "-30px",
    marginBottom: '22px',
    boxShadow: '1px 1px grey',
  },
  pushRight: {
    marginLeft: 'auto',
    marginBottom: '20px',
  },
  event_card: {
    padding: '10px',
    backgroundColor: 'white',
  },
  chip: {
    margin: '10px',
  },
  actionButton: {
    position: 'relative',
    left: '160px',
    top: '-20px',
    paddingLeft: '20px',
    paddingRight: '20px',
    textTransform: 'none',
    backgroundColor: '#c44a33',
    color: 'white',
  },
  eateryTitle: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1.48375rem',
    fontWeight: '600',
    lineHeight: '29px',
    letterSpacing: '0px',
  },
  articleBtn: {
    width: 'auto',
    padding: '10px',
    border: '1px solid black',
    borderRadius: '20px',
  },
  profileSec: {
    fontSize: '33.4px',
    color: 'white',
  },
  cityExportBtn: {
    color: 'grey',
    backgroundColor: 'white',
  },
  contCard: {
    padding: '20px',
    backgroundColor: 'white',
  },
};

const FollowCards = ({ followerData }) => {
  let displayCards;
  displayCards = shuffle(followerData).map((follower, i) => {
    return (
      <Follower
        key={follower.userName + i}
        style={{ margin: '15px 0px' }}
        id={follower.id}
        username={follower.displayName ? follower.displayName : follower.name}
        articleCount={follower.articleCount ? follower.articleCount : ''}
        profilePic={follower.profilePic.uri}
        expertsIn={
          follower.cuisinesOfExpertise ? follower.cuisinesOfExpertise : ''
        }
      />
    );
  });
  return <VerticalSliders>{displayCards}</VerticalSliders>;
};

const ArticleEatery = ({ eateryData }) => {
  return (
    <Grid container>
      <Grid item xs={12} style={{ marginTop: '7px' }}>
        <Card>
          <CardMedia
            component="img"
            alt="Contemplative Reptile"
            height="140"
            image={eateryData.image}
            title="user_image"
          />
          <CardContent style={{ textAlign: 'left' }}>
            <Typography
              gutterBottom
              variant="h5"
              component="h5"
              style={styles2.eateryTitle}
            >
              {eateryData.title}
            </Typography>
            <Typography
              variant="h6"
              component="h6"
              style={{
                textAlign: 'left',
                fontSize: '0.953125rem',
                lineHeight: '1.5em',
              }}
            >
              <i>{eateryData.location}</i>
            </Typography>

            <Typography
              variant="subtitle2"
              component="h5"
              style={{
                textAlign: 'left',
                fontSize: '0.953125rem',
                lineHeight: '1.5em',
              }}
            >
              {eateryData.cuisine}
            </Typography>
            <br />
            <Typography
              component="p"
              variant="body1"
              style={{
                textAlign: 'left',
                fontSize: '1.089375rem',
                lineHeight: '1.5em',
              }}
            >
              {eateryData.story}
            </Typography>
          </CardContent>
          <CardActions style={styles2.actions}>
            <div style={styles2.pushRight}>
              <IconButton
                style={styles2.actionIcon}
                color="secondary"
                aria-label="Bookmark"
              >
                <BookmarkIcon />
              </IconButton>
            </div>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};

const ArticleListicle = ({ listicleData }) => {
  // console.log(listicleData);
  return (
    <Grid container>
      <Grid item xs={12} style={{ marginTop: '7px' }}>
        <Card>
          <CardContent style={{ textAlign: 'left' }}>
            <Typography
              gutterBottom
              variant="h5"
              component="h5"
              style={styles2.eateryTitle}
            >
              {listicleData.title}
            </Typography>
            <Typography
              variant="h6"
              component="h6"
              style={{
                textAlign: 'left',
                fontSize: '0.953125rem',
                lineHeight: '1.5em',
              }}
            >
              <b>{listicleData.date}</b> | {listicleData.location}
            </Typography>
            <br />
            <Typography
              component="p"
              variant="body1"
              style={{
                textAlign: 'left',
                fontSize: '1.089375rem',
                lineHeight: '1.5em',
              }}
            >
              {listicleData.story}
            </Typography>
          </CardContent>
          <CardActions style={styles2.actions}>
            <Button
              style={styles2.actionButton}
              color="inherit"
              variant="contained"
            >
              Attend
            </Button>
            <div style={styles2.pushRight}>
              <IconButton
                style={styles2.actionIcon}
                color="secondary"
                aria-label="Bookmark"
              >
                <BookmarkIcon />
              </IconButton>
            </div>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};

const ArticleStory = ({ storyData }) => {
  return (
    <Grid container>
      <Grid item xs={12} style={{ marginTop: '7px' }}>
        <Card>
          <CardContent style={{ textAlign: 'left' }}>
            <Typography
              gutterBottom
              variant="h5"
              component="h5"
              style={styles2.eateryTitle}
            >
              {storyData.title}
            </Typography>
            <br />
            <Typography
              component="p"
              variant="body1"
              style={{
                textAlign: 'left',
                fontSize: '1.089375rem',
                lineHeight: '1.5em',
              }}
            >
              {storyData.story}
            </Typography>
          </CardContent>
          <CardActions style={styles2.actions}>
            <Button
              style={styles2.actionButton}
              color="inherit"
              variant="contained"
            >
              Visit Article
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};

// const ContTopCards = ({ cards }) => {
//   let displayCards = [];
//   cards.map(card => {
//     switch (card.type) {
//       case 'article':
//         displayCards.push(<ContExpCard data={card} />);
//         return 0;
//       case 'eatery':
//         displayCards.push(<RnFEatery data={card} />);
//         return 0;
//       case 'event':
//         displayCards.push(<RnFEvent data={card} />);
//         return 0;
//       case 'experience':
//         displayCards.push(<RnFExperience data={card} />);
//         return 0;
//       default:
//         displayCards.push('');
//         return 0;
//     }
//   });

//   return (
//     <HorizontalSlider
//       children={displayCards}
//       cols={1.2}
//       slideHeight={420}
//       spacing={10}
//     />
//   );
// };

// const FnRCards = ({ cards }) => {
//   let displayCards = [];
//   cards.map(card => {
//     switch (card.type) {
//       case 'article':
//         displayCards.push(<ArticleCard data={card} />);
//         return 0;
//       case 'eatery':
//         displayCards.push(<RnFEatery data={card} />);
//         return 0;
//       case 'event':
//         displayCards.push(<RnFEvent data={card} />);
//         return 0;
//       case 'experience':
//         displayCards.push(<RnFExperience data={card} />);
//         return 0;
//       default:
//         displayCards.push('');
//         return 0;
//     }
//   });
//   return (
//     <HorizontalSlider
//       children={displayCards}
//       cols={1.2}
//       slideHeight={420}
//       spacing={10}
//     />
//   );
// };

const ProfileCard = ({ user }) => {
  const profileCheck = user.userProfile ? user.userProfile : '';
  const hometownCheck = profileCheck.hometown ? profileCheck.hometown : '';
  const homeNameCheck = hometownCheck.name ? hometownCheck.name : '';
  const checkProfilePic = user.profilePic ? user.profilePic : '';
  return (
    <div style={styles2.cont_container}>
      <Grid container>
        <Grid item xs={12}>
          <div style={styles2.avatar_container}>
            <Avatar
              style={styles2.avatar_pic}
              alt="user_pic"
              src={
                checkProfilePic.uri ? checkProfilePic.uri : '/icons/user.png'
              }
            />
          </div>
          <h3 style={styles2.profile_name}>
            {user.displayName
              ? user.displayName.toUpperCase()
              : user.name.toUpperCase()}
          </h3>
          <p style={{ textAlign: 'center', color: 'black' }}>
            {homeNameCheck}
            {homeNameCheck ? ',India' : ''}
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

class UserProfile extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      labelWidth: 0,
    };
  }
  componentDidMount() {
    this.props.dispatch(actions.getData(this.props.match.params.user_id));
  }
  render() {
    const { classes, loading, followedContributors, userData } = this.props;

    const eaterydata = articleEateryDummyData;
    const storydata = articleStoryDummyData;
    const listicledata = articleListicleDummyData;

    const fetchingEvent = EventDummyData.map((eventfetch, id) => {
      return (
        <div key={id}>
          <RnFEvent
            name={eventfetch.title}
            curatedBy={eventfetch.curatedBy}
            date={eventfetch.date}
            location={eventfetch.location}
            img={eventfetch.img}
            summary={eventfetch.story}
          />
        </div>
      );
    });

    if (loading) {
      const loadText = 'Loading your profile.Please wait..';
      return <ProfileLoader loadingText={loadText} />;
    } else {
    }
    return (
      <div style={{ overflowX: 'hidden' }}>
        <Grid container>
          <Grid item xs={12} className={classes.ImgContainer}>
            <ProfileCard user={userData} />
          </Grid>
        </Grid>

        <Grid container />

        <div className={classes.contCard}>
          {followedContributors.content.length > 0 ? (
            <Typography variant="body2" className={classes.top}>
              {' FOLLOWED CONTRIBUTORS '}
            </Typography>
          ) : (
            ''
          )}

          {/* <ContributeCard contributors={topContributors} /> */}
          <FollowCards followerData={followedContributors.content} />
        </div>

        <div
          style={{
            backgroundColor: '#fbfbfa',
            height: 'auto',
            marginTop: '20px',
            marginBottom: '20px',
            paddingBottom: '20px',
          }}
        >
          <Typography
            variant="subtitle1"
            component="p"
            style={{
              paddingTop: '20px',
              paddingLeft: '10px',
              marginBottom: '10px',
            }}
          >
            TAGS FOLLOWED
          </Typography>
          <Grid container spacing={8} style={{ padding: '10px' }}>
            {contributorChips.map((chips, id) => {
              return (
                <Grid item sm key={chips.id}>
                  <Chip
                    label={chips.label}
                    className={classes.chip}
                    variant="outlined"
                  />
                </Grid>
              );
            })}
          </Grid>

          <Typography
            variant="subtitle1"
            component="p"
            style={{
              paddingTop: '20px',
              paddingLeft: '10px',
              marginBottom: '10px',
            }}
          >
            SEE ALL...
          </Typography>
        </div>

        <div className={classes.eventCard}>
          <Typography variant="subtitle1" component="p" className={classes.top}>
            {'EVENTS ATTENDED'}
          </Typography>
          <HorizontalSlider
            children={fetchingEvent}
            cols={1.2}
            slideHeight={420}
            spacing={10}
          />
          {/* <CardsSlider history={history} cards={experiences} /> */}
          {/* <div style={{padding:'10px'}}>
            <FnRCards cards={eventdata} />
            </div> */}
          {/* <div style={{padding:'10px'}}>
               <ContTopCards cards={EventDummyData}/>
            </div> */}
          {/* <RnFEvent name="Event Name" curatedBy="Maheima Kapur" date="23 Nov 2018" location="Bengaluru" img='/img/e2.png' summary='This is testing'/> */}
        </div>
        <div className={classes.whiteContainer}>
          <div className={classes.eateryCard}>
            <Typography variant="body2" className={classes.top}>
              {'RECENT ACTIVITIES'}
            </Typography>
            <div className={classes.top}>
              {/* <CardsSlider history={history} cards={localEateries} /> */}
              <ArticleEatery eateryData={eaterydata} />
              <br />
            </div>
          </div>

          <div
            style={{ marginLeft: 'auto', marginRight: 'auto', padding: '10px' }}
          >
            <ArticleStory storyData={storydata} />
            <br />
            <ArticleStory storyData={storydata} />
            <br />
            <ArticleEatery eateryData={eaterydata} />
            <br />
            <ArticleStory storyData={storydata} />
            <br />
            <ArticleListicle listicleData={listicledata} />
            <br />
            <ArticleStory storyData={storydata} />
            <br />
          </div>
        </div>
      </div>
    );
  }
}

UserProfile.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(UserProfile));
